import { blackLight } from '../../shadows';

// This is a hack until we update to a version of withStyles that supports
// passing in props. We can then just grab the value prop and set it here. This
// style isn't perfectly accurate, since we don't go to each decimal place.
const widthStyles = {};
for (let i = 1; i <= 100; i++) {
  widthStyles[`&[aria-valuenow="${i}"]`] = {
    '& > span': {
      width: `${i}%`,
      minWidth: 12,
    },
  };
}

export const classes = {
  root: {
    height: 12,
    '&[aria-valuenow="0"]': {
      '& > span': {
        minWidth: 0,
      },
    },
    ...widthStyles,
    borderRadius: 24,
  },
  colorPrimary: {
    backgroundColor: blackLight,
    height: 12,
  },
  bar1Determinate: {
    width: 0,
    '&[style]': {
      transform: 'none !important',
    },
  },
  bar: {
    borderRadius: 24,
  },
};
